
import React from 'react';

const HeroSection = () => {
  return (
    <section className="bg-gradient-to-r from-blue-50 to-indigo-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl">
          About <span className="text-ai-indigo">AI Nexus</span>
        </h1>
        <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
          We're on a mission to democratize AI knowledge and empower individuals and organizations with cutting-edge artificial intelligence insights.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
